import Axios from "axios";
import { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap"
import { toast } from "react-toastify";
import DashboardContext from "../../../../Context";
import ModalAddWorkDay from "./ModalAddWorkDay"
import ModalDeleteWorkDay from "./ModalDeleteWorkDay";

export default function TabelWrokDay({ userId }) {
    const { sideBardata, authentication, urldashboard, handelloding, idview } = useContext(DashboardContext);

    const [dataFech, setDataFech] = useState({})

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);


    const handeladd = () => setShow(true);

    const [showDeletemodal, setShowDeletemodal] = useState(false)

    const handelCloseModalDelete = () => setShowDeletemodal(false)


    const [idDay, setIdDay] = useState()

    const handeldelete = (id) => {
        setIdDay(id)
        setShowDeletemodal(true)
    }


    const handelcreate = () => handleClose()

    const dataFeching = async () => {
        const formdata = {
            "page": parseInt(1),
            "pageSize": parseInt(40),
            "search": "",
        }


        try {
            const res = await Axios.post(`${urldashboard}/workday/get/${userId ? userId : idview}`, JSON.stringify(formdata), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })
            const data = await res.data
            setDataFech(data)
            handelloding(false)

        } catch (error) {
            if (error.message === 'Network Error') {
                toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                handelloding(false)
            }


        }
    }



    useEffect(() => {
        dataFeching()

        return () => {

        }
    }, [show, showDeletemodal, userId])

    return (
        <>
            <button type="button" onClick={handeladd}
                className="btn btn-primary btn-icon-text btn-sm mr-auto mt-2 d-flex mb-3">افزودن روز<i className="fa fa-plus fa-lg mr-2"></i></button>

            <h2 style={{ fontSize: '16px' }} className='mt-2' >روز های کاری نیرو</h2>
            <Table hover className='tabeleWorkDay_Wor-profile'>
                <thead>
                    <tr>
                        <th>#</th>
                        {dataFech.hasOwnProperty("headers") ?
                            dataFech.headers.map(item => item.name === 'id' ?
                                null
                                :
                                <th key={item.name} > {item.label}</th>)
                            : null
                        }
                    </tr>
                </thead>
                <tbody>
                    {dataFech.hasOwnProperty("data") ?
                        dataFech.data.map(item =>
                            <tr key={item.id} >
                                <td className='btndeletetabeleWorkDay' onClick={() => handeldelete(item.id)} >
                                    <i className="mdi mdi-delete-forever"></i>
                                </td>
                                <td>{item.dayOfWeekTitle}</td>
                                <td>{item.startTime}</td>
                                <td>{item.endTime}</td>
                            </tr>
                        )
                        : null
                    }


                </tbody>
            </Table>
            <ModalAddWorkDay show={show} handleClose={handleClose} handelcreate={handelcreate} />
            <ModalDeleteWorkDay showmodal={showDeletemodal}
                handelCloseModalDelete={handelCloseModalDelete} idDay={idDay} />
        </>
    )
}
